import { useQuery } from "@apollo/client";
import { GET_PAYMENTS } from "graphql/payment";
import {
  formatPaymentForFormik,
  FormikPayment,
} from "utils/payments/paymentFormat";

export const useGetLatestPayments = (contactId?: string) => {
  const { data, loading, refetch } = useQuery(GET_PAYMENTS, {
    variables: {
      first: 5,
      sortDirection: "DESC",
      ...(contactId ? { contactId } : {}),
    },
    fetchPolicy: "cache-and-network",
  });

  const latestPayments: FormikPayment[] = Array.isArray(data?.payments?.edges)
    ? data.payments.edges.map((edge: { node: unknown }) =>
        formatPaymentForFormik(edge.node),
      )
    : [];

  return {
    latestPayments,
    loadingLatestPayments: loading,
    refetchLatestPayments: refetch,
  };
};
